export default "__VITE_ASSET__CHJIepVC__"